import { render } from "./RengZhengZiYuanView.vue?vue&type=template&id=c6340f02&scoped=true"
import script from "./RengZhengZiYuanView.vue?vue&type=script&lang=js"
export * from "./RengZhengZiYuanView.vue?vue&type=script&lang=js"

import "./RengZhengZiYuanView.vue?vue&type=style&index=0&id=c6340f02&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6340f02"]])

export default __exports__